import { useState, useEffect } from "react";
import { instanceAxiosApiFiliado } from "../dataProviders";

const useApiFiliado = (url, metodo='GET') => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    instanceAxiosApiFiliado({
      method: metodo,
      url: url
    })
      .then((response) => {
        setIsLoading(false);
        setData(response.data);
      })
      .catch((error) => {
        setIsLoading(false);
        setIsError(true);
      });
  }, [url, metodo]);

  return { isLoading, isError, data };
};

export default useApiFiliado;
